export class Entry {
  constructor(
    public moles: number,
    public lat: number,
    public lng: number,
    public client: string,
    public month: string,
    public year: number
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/entry.model.ts